<template>
  <v-app v-if="userAuth" class="app-root">
    <app-toolbar class="app--toolbar" @side-icon-click="handleDrawerVisiable" />
    <v-main>
      <!-- Page Wrapper -->
      <div class="page-wrapper mx-6">
        <app-breadcrumbs></app-breadcrumbs>
        <el-sistema-info />
        <router-view />
      </div>
      <!-- App Footer -->
      <app-footer></app-footer>
    </v-main>
    <!-- Go to top -->
    <app-fab />
    <modal-idle v-model="showIdle" />
  </v-app>
</template>

<script>
import checkUser from '@/mixins/checkUser'
import AppToolbar from '@/components/layouts/turtas/AppToolbar'
import AppBreadcrumbs from '@/components/layouts/turtas/AppBreadcrumbs'
import AppFab from '@/components/layouts/turtas/AppFab'
import AppFooter from '@/components/layouts/turtas/AppFooter'
import ModalIdle from '../modals/ModalIdle'

export default {
  name: 'LayoutDefault',
  components: {
    AppToolbar,
    AppBreadcrumbs,
    AppFab,
    AppFooter,
    ModalIdle,
  },
  mixins: [checkUser],
  data() {
    return {
      userAuth: false,
      showDrawer: true,
      showIdle: false,
    }
  },
  computed: {
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
  },
  watch: {
    isAppIdle(val) {
      if (val && !this.showIdle && !this.isLocal) {
        this.$store.dispatch('unlockObj')
        this.$store.dispatch('logout').then(() => {
          this.showIdle = true
        })
      }
    },
  },
  created() {
    this.handleMetaData()
    this.checkUser()
    this.$store.dispatch('unlockObj')
    this.$store.dispatch('unlockPra')
  },
  methods: {
    handleDrawerVisiable() {
      this.$refs.drawer.toggleDrawer()
    },
    handleMetaData() {
      const favicon = document.getElementById('favicon')
      favicon.href = `${process.env.VUE_APP_SAVITARNA_URL}faviconTurtas.ico`
      const title = document.getElementById('appTitle')
      title.innerHTML = 'Turtas'
    },
  },
}
</script>

<style lang="sass" scoped>
.app-root
  background: #f5f5f5
.page-wrapper
  min-height: calc(100vh - 112px - 200px)
</style>
